import { NgModule } from '@angular/core'
import { CommonModule } from '@angular/common'
import { FormsModule, ReactiveFormsModule } from '@angular/forms'
import { SeFeButtonModule } from 'se-fe-button'
import { SeFeFormFieldModule } from 'se-fe-form-field'
import { SeFeFormFieldOptionsModule } from 'se-fe-form-field-options'
import { SeFeSpinnerModule } from 'se-fe-spinner'

import { MatchComponent } from './match/match.component'
import { MatchFormCreateService } from './match/match-form-create.service'
import { MatchFormSubmitService } from './match/match-form-submit.service'

@NgModule({
  declarations: [
    MatchComponent
  ],
  exports: [
    MatchComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    SeFeButtonModule,
    SeFeFormFieldModule,
    SeFeFormFieldOptionsModule,
    SeFeSpinnerModule,
  ],
  providers: [
    MatchFormCreateService,
    MatchFormSubmitService
  ],
})
export class SeHouseholdSetupFeatureMatchModule {}
